import { useNavigate } from "react-router";
import "./Header.css";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Trans } from "react-i18next";

function Header() {
  let navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [events, setEvents] = useState();
  return (
    <>
      <div className="relative w-full h-16 bg-green-600 z-50 font-[ Open Sans,sans-serif ] text-[50px] font-semibold">
        <nav className="inline md:hidden overflow-y-hidden">
          <div class="navbar">
            <div class="container nav-container">
              <input class="checkbox" type="checkbox" name="" id="" />
              <div class="hamburger-lines">
                <span class="line line1"></span>
                <span class="line line2"></span>
                <span class="line line3"></span>
              </div>
              <div class="menu-items">
                <div className="">
                  <li
                    className="w-1/6 inline-block align-top"
                    style={{
                      fontWeight:
                        i18n.resolvedLanguage === "en" ? "bold" : "normal",
                    }}
                    type="submit"
                    onClick={() => i18n.changeLanguage("en")}
                  >
                    {" "}
                    EN
                  </li>
                  <li
                    className="w-1/6 inline-block align-top"
                    style={{
                      fontWeight:
                        i18n.resolvedLanguage === "nl" ? "bold" : "normal",
                    }}
                    type="submit"
                    onClick={() => i18n.changeLanguage("nl")}
                  >
                    {" "}
                    NL
                  </li>
                </div>

                <li className="">Klinker</li>
                <li>
                  <a href="https://www.instagram.com/deklinkernijmegen/">
                    Instagram
                  </a>
                </li>
                <li className="mt-4">De Onderbroek</li>
                <li>
                  <a href="https://www.instagram.com/deonderbroek/">
                    Instagram
                  </a>
                </li>
                <li className="mt-4 bg-yellow-400">
                  <a href="/buy-de-broek-fundraiser">
                    <Trans i18nKey="acquisition.adtext">
                      // WIJ KOPEN DE BROEK! //
                    </Trans>
                  </a>
                </li>
              </div>
            </div>
          </div>
        </nav>
        <div className="ml-0 mr-auto text-2xl font-semibold float-right p-6">
          <nav class="nav hidden md:block">
            <ul class="nav__menu">
              <li
                class="nav__menu-item  bg-[#FFD700] text-black"
                onClick={() => navigate("/buy-de-broek-fundraiser")}
              >
                <a>
                  <Trans i18nKey="acquisition.adtext">
                    // BUYING THE BUILDING //
                  </Trans>
                </a>
              </li>
              <li class="nav__menu-item">
                <a>Klinker</a>
                <ul class="nav__submenu">
                  {/* <li class="nav__submenu-item"> <a>{t('Information')}</a></li> */}
                  <li class="nav__submenu-item">
                    {" "}
                    <a href="https://www.instagram.com/deklinkernijmegen/">
                      Instagram
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav__menu-item">
                <a>Onderbroek</a>
                <ul class="nav__submenu">
                  {/* <li class="nav__submenu-item"> <a>{t('Information')}</a></li> */}
                  <li class="nav__submenu-item">
                    {" "}
                    <a href="https://www.instagram.com/deonderbroek/">
                      Instagram
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav__menu-item">
                <a>{i18n.language}</a>
                {/* <button onClick={() => console.log}>test</button> */}
                <ul class="nav__submenu">
                  <li
                    className="ml-4"
                    style={{
                      fontWeight:
                        i18n.resolvedLanguage === "en" ? "bold" : "normal",
                    }}
                    type="submit"
                    onClick={() => i18n.changeLanguage("en")}
                  >
                    {" "}
                    EN
                  </li>
                  <li
                    className="ml-4"
                    style={{
                      fontWeight:
                        i18n.resolvedLanguage === "nl" ? "bold" : "normal",
                    }}
                    type="submit"
                    onClick={() => i18n.changeLanguage("nl")}
                  >
                    {" "}
                    NL
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>
        <div
          className="left-6 top-6 absolute z-10 leading-none cursor-pointer"
          onClick={() => navigate("/")}
        >
          <div>DE</div>

          <div className="font-light"> GROTE </div>
          <div>BROEK</div>
        </div>
      </div>

      <div className="w-full bg-green-600 slanted"></div>
    </>
  );
}

export default Header;
